import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-568479ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "imgstyle",
  alt: "logo",
  title: "logo"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "font-light"
}
const _hoisted_3 = {
  key: 1,
  class: "headermenudiv hidemenu"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_5 = { class: "complbldiv" }
const _hoisted_6 = {
  key: 0,
  class: "complabel hidemenu",
  style: {"font-weight":"700","margin-bottom":"0"}
}
const _hoisted_7 = { class: "dropdowndiv" }
const _hoisted_8 = {
  class: "complabel",
  style: {"margin-bottom":"0"}
}
const _hoisted_9 = { class: "showham divmargin" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"25px"},
  title: "Menu",
  alt: "Menu"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_UsefullLinks = _resolveComponent("UsefullLinks")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_HeaderSideBar = _resolveComponent("HeaderSideBar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      class: "el-menu-demo",
      mode: "horizontal",
      ellipsis: false,
      "menu-trigger": "click",
      "default-active": _ctx.activeIndex,
      onSelect: _ctx.handleSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        (!_ctx.fetchCurrentUser)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Accounts"))
          : _createCommentVNode("", true),
        (_ctx.userRole !== 'User' && _ctx.userAuthenitcated && !_ctx.fetchCurrentUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_menu_item, {
                index: "/account",
                class: "menulabel",
                onClick: _ctx.tabClicked
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Overview ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_menu_item, {
                index: "/products",
                class: "menulabel",
                onClick: _ctx.tabClicked
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Products & Services ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_menu_item, {
                index: "/users",
                class: "menulabel",
                onClick: _ctx.tabClicked
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Users ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_menu_item, {
                index: "/companies",
                class: "menulabel",
                onClick: _ctx.tabClicked
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Companies ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              (
          _ctx.userRole == 'Superadmin' ||
          _ctx.userRole == 'Admin' ||
          _ctx.userRole == 'VCUser'
        )
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    index: "/ProductKeys",
                    class: "menulabel",
                    onClick: _ctx.tabClicked,
                    "data-cy": "productkeys-nav-header"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Product Keys ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.userRole !== 'User')
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(_ctx.currentUserCompany.companyName), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_sub_menu, {
          index: "4",
          class: "divborder hidemenu"
        }, {
          title: _withCtx(() => [
            _createVNode(_component_el_button, {
              circle: "",
              class: "namebtn",
              type: "warning",
              id: "nameinitials",
              alt: "Account Options",
              title: "Click for account options"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.nameInitials), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item_group, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.userName) + " ", 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_menu_item, {
              index: "2-1",
              class: "menu-font",
              onClick: _ctx.onmyaccount
            }, {
              default: _withCtx(() => [
                _createTextVNode(" My Profile ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_menu_item, {
              index: "2-1",
              class: "menu-font",
              id: "logout",
              onClick: _ctx.onlogout
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Logout ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_menu_item_group, { style: {"background":"#efefef"} }, {
              default: _withCtx(() => [
                _createVNode(_component_UsefullLinks)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _ctx.showHeaderSideBar,
            link: "",
            size: "large",
            id: "showsideheader",
            title: "menuhambtn"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["default-active", "onSelect"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.ShowSideHeader,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ShowSideHeader) = $event)),
      direction: "rtl",
      size: "30%",
      class: "showham"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HeaderSideBar)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}